import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

import { AuthenticationService } from '../services/authentication.service';
import { NotificationService } from '../services/notification.service';

export const roleRestrictionGuard: CanActivateFn = (route, state): boolean => {
  const authenticationService = inject(AuthenticationService);
  const notificationService = inject(NotificationService);
  const router = inject(Router);

  if (authenticationService.isAuthorized(route.data['roleRestriction'])) {
    return true;
  } else {
    router.navigate(['']);
    notificationService.showToast('You don\'t have permission to access this section', { type: 'warning' });
    return false;
  }
};
